<template>
  <div id="data-list-list-view" class="datatable-container">

    <payment-export-form
      :visible="sidebarVisibility"
      @closeSidebar="toggleDataSidebar"
      v-if="sidebarVisibility"
      :to-exports="sidebarData"
    />

    <!--Filter-->
    <payment-filter @change="onChangeFilter" />

    <vx-card class="mt-5">
      <h4 class="card-title">Results ({{ totalItem }})</h4>
      <vs-table multiple stripe ref="table" v-model="selected" :data="transactions">
        <div slot="header" class="flex flex-wrap-reverse flex-grow justify-end mb-6">
          <div class="flex flex-wrap-reverse data-list-btn-container">
            <vs-button v-if="this.toExports.length > 0" @click="onExport()" color="primary" type="border" size="small" class="ml-3">Export</vs-button>
          </div>
        </div>

        <template slot="thead">
          <vs-th sort-key="id">Transaction ID</vs-th>
          <vs-th sort-key="status">Status</vs-th>
          <vs-th sort-key="customer">Customer</vs-th>
          <vs-th sort-key="amount">Amount</vs-th>
          <vs-th sort-key="date">Date</vs-th>
          <vs-th sort-key="type">Type</vs-th>
          <vs-th sort-key="action">Action</vs-th>
        </template>
        <template slot-scope="{ data }">
          <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-name"><a @click="onView(tr)">{{ tr.id }}</a></p>
            </vs-td>
            <vs-td>
              <vs-chip
                :color="getTransactionStatusColor(tr.status)"
                class="product-order-status">
                {{ tr.status }}
              </vs-chip>
            </vs-td>
            <vs-td>
              <p class="product-name"> {{ tr.customer.customerId }} </p>
              <p class="product-name"> {{ tr.customer.name }} </p>
            </vs-td>
            <vs-td>
              <p class="product-name"> 
                {{ (tr.amount ? tr.amount : 0) | toCurrency(tr.currency ? tr.currency : '') }}
              </p>
            </vs-td>
            <vs-td>
              <p class="product-name"> {{ tr.createdAt | moment('DD MMM YYYY, hh:mm A') }}</p>
            </vs-td>
            <vs-td>
              <vs-chip
                color="success"
                class="product-order-status">
                {{ tr.type }}
              </vs-chip>
            </vs-td>
            <vs-td class="whitespace-no-wrap">
              <feather-icon v-if="getRefreshableStatus(tr.status)"
                icon="LoaderIcon"
                svgClasses="w-5 h-5 hover:text-success stroke-current"
                class="ml-2"
                @click.stop="onRefresh(tr)"
              />
              <feather-icon
                icon="EyeIcon"
                svgClasses="w-5 h-5 hover:text-success stroke-current"
                class="ml-2"
                @click.stop="onView(tr)"
              />
              <feather-icon v-if="tr.status !== 'success' "
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="handleDelete(tr)"
              />
            </vs-td>
          </vs-tr>
          </tbody>
        </template>
      </vs-table>
      <template v-if="totalPage > 0">
        <vs-pagination
          :total.sync="totalPage"
          v-model="currentPage"
        ></vs-pagination>
      </template>
    </vx-card>
  </div>
</template>

<script>
  import PaymentFilter from './PaymentTransactionFilter.vue'
  import PaymentExportForm from './PaymentTransactionExportForm.vue'
  import PaymentForm from './PaymentTransactionForm.vue'
  import TransactionStatus from "@/mixins/transaction-status";

  export default {
    components: {
      PaymentFilter,
      PaymentForm,
      PaymentExportForm
    },
    mixins: [TransactionStatus],
    data () {
      return {
        selected: [],
        itemsPerPage: 25,
        isMounted: false,
        currentPage: 1,
        pageTotal: 0,
        totalItem: 0,
        totalPage: 0,
        sortBy: 'createdAt,DESC',
        search: {},
        sidebarVisibility: false,
        sidebarData: {},
        toExport: {},
        toExports: [],
      }
    },
    watch: {
      currentPage (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.getRecords()
        }
      },
      selected(newValue){
        this.toExports = []
        newValue.forEach(nv => {
          if(nv.status !== 'completed') {
            this.toExport = {}
            this.toExport.id = nv.id
            this.toExports.push(this.toExport)
          }
        })
      }
    },
    computed: {
      transactions () {
        return this.$store.state.transactions.transactions || []
      },
      queriedItems () {
        if (this.$store.state.transactions.pagination) {
          return this.$store.state.transactions.pagination.total
        }
        return 0
      },
      filterParams () {
        const entries = Object.entries(this.filter)
        if (!entries.length) return null

        return entries
          .filter(([, value]) => value)
          .map(([key, value]) => ({ [key]: key === 'status'? value : { $contL: value } }))
      },
      sortParams () {
        const entries = Object.entries(this.sortBy)
        return entries.length
          ? entries.map(([field, direction]) => `${field},${direction}`).join('')
          : ''
      }
    },
    created () {
      this.getRecords()
    },
    methods: {
      async getRecords () {
        try {
          let response = await this.$store.dispatch(
            'transactions/fetchRecords',
            {
              page: this.currentPage,
              limit: this.itemsPerPage,
              s: this.search,
              sort: this.sortBy
            }
          )

          this.currentPage = parseInt(response.headers['x-pagination-page'])
          this.pageTotal = parseInt(response.headers['x-pagination-count'])
          this.totalItem = parseInt(response.headers['x-pagination-total'])
          this.totalPage = parseInt(response.headers['x-pagination-page-count'])
        } catch (e) {
          console.error(e.toString())
        }
      },
      onView (item) {
        this.$router.push('/payment-transactions/' + item.id).catch(() => {});
      },
      onExport () {
        this.sidebarData = this.toExports
        this.toggleDataSidebar(true)

      },
      handleDelete (item) {
        this.deleteId = item.id
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: this.$t('invoice.message.ConfirmDelete'),
          text: this.$t('invoice.message.ConfirmDeleteMessage', {
            item: item.id
          }),
          accept: this.deleteRecord,
          acceptText: 'Delete'
        })
      },
      async deleteRecord () {
        try {
          const response = await this.$store.dispatch(
            'transactions/removeRecord',
            this.deleteId
          )
          if (response.status !== 200) {
            throw 'unable to deleted'
          }
          this.showDeleteSuccess()
        } catch (err) {
          this.$vs.notify({
            color: 'danger',
            title: this.$t('invoice.message.FailedTitle'),
            text: err.response.data.message
          })
        }
      },
      showDeleteSuccess () {
        this.$vs.notify({
          color: 'success',
          title: 'Transaction Has Been Deleted',
          text: 'The selected transaction has been deleted successfully.'
        })
        this.getRecords();
      },
      async onRefresh (item) {
        try {
          this.$vs.notify({
            color: 'primary',
            title: "Refreshing Transaction Status",
            text: "We're currently refreshing the payment transaction status"
          });

          await this.$store.dispatch(
            'transactions/refreshRecord',
            { id: item.id}
          );

          this.$vs.notify({
            color: 'success',
            title: "Transaction Status Has Been Refreshed",
            text: "Selected transaction has been refreshed."
          });
        } catch (e) {
          console.error(e.toString())
        }
      },
      async onChangeFilter(search) {
        this.currentPage = 1;
        this.search = search;
        await this.getRecords();
      },
      toggleDataSidebar (val = false) {
        this.sidebarVisibility = val
      },
    },
    mounted () {
      this.isMounted = true
    }
  }
</script>
